var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleGraphicFour2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 261,
    viewBox: "0 0 261 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M130.67 260.9C58.9999 260.9 0.689941 202.59 0.689941 130.92C0.689941 59.25 58.9999 0.930054 130.67 0.930054C202.34 0.930054 260.65 59.2401 260.65 130.91C260.65 202.58 202.34 260.89 130.67 260.89V260.9ZM130.67 2.93005C60.0999 2.93005 2.68994 60.3401 2.68994 130.91C2.68994 201.48 60.0999 258.89 130.67 258.89C201.24 258.89 258.65 201.48 258.65 130.91C258.65 60.3401 201.24 2.93005 130.67 2.93005Z",
    fill: "url(#paint0_linear_229_415)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_229_415",
    x1: 38.7999,
    y1: 39.0501,
    x2: 222.54,
    y2: 222.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D46D1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#8D46D1",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8D46D1",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8D46D1",
    stopOpacity: 0.2401
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8D46D1",
    stopOpacity: 0.4225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8D46D1",
    stopOpacity: 0.6084
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#8D46D1",
    stopOpacity: 0.7744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8D46D1",
    stopOpacity: 0.9025
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D46D1",
    stopOpacity: 0.9801
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D46D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGraphicFour2);
export default __webpack_public_path__ + "static/media/circle-graphic-four-2.c092f9b4f556f859f66b074cf872fae4.svg";
export { ForwardRef as ReactComponent };